var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.66675C6.36364 2.66675 3.25818 4.92857 2 8.12129C3.25818 11.314 6.36364 13.5758 10 13.5758C13.6364 13.5758 16.7418 11.314 18 8.12129C16.7418 4.92857 13.6364 2.66675 10 2.66675ZM10 11.7577C7.99273 11.7577 6.36364 10.1286 6.36364 8.12129C6.36364 6.11402 7.99273 4.48493 10 4.48493C12.0073 4.48493 13.6364 6.11402 13.6364 8.12129C13.6364 10.1286 12.0073 11.7577 10 11.7577ZM10 5.93948C8.79273 5.93948 7.81818 6.91402 7.81818 8.12129C7.81818 9.32857 8.79273 10.3031 10 10.3031C11.2073 10.3031 12.1818 9.32857 12.1818 8.12129C12.1818 6.91402 11.2073 5.93948 10 5.93948Z",
    fill: "#4D4D4D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.36327,
    y: 14.7764,
    width: 21.259,
    height: 2,
    transform: "rotate(-41.3803 1.36327 14.7764)",
    fill: "#4D4D4D",
    stroke: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye_off.55293ac4f23c468e8e6760473f9f35db.svg";
export { ForwardRef as ReactComponent };